/* =============================================================================
   NULL. — theme behaviors. Dependency-free ports of the React FX components:
   dawn watcher, cursor light, scroll reveals, kinetic text, the 03:17 alarm
   clock (7-segment SVG), the 4-7-8 breathing exercise, the archive log,
   the five-states footer easter egg, and small commerce helpers.
   ========================================================================== */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ------------------------------------------------------- console signature */
  try {
    var dim = "color:#8d8d8d";
    var sig = "color:#2ba2d6";
    console.log("%cNULL.", "color:#e5e5e5;font-size:20px;letter-spacing:4px");
    console.log(
      "%c01 %cTHE HOURS NOBODY SEES.\n%c02 %c[ENCRYPTED]\n%c03 %c[ENCRYPTED]\n%c04 %c[ENCRYPTED]\n%c05 %c[ENCRYPTED]\n%cthe night ends.",
      sig, dim, sig, dim, sig, dim, sig, dim, sig, dim, sig
    );
  } catch (e) { /* noop */ }

  /* ------------------------------------------- dawn mode: the hour returns */
  var DAWN_HOUR = 3;
  var DAWN_MINUTE = 17;

  function shouldBeDawn() {
    var param = new URLSearchParams(window.location.search).get("dawn");
    if (param === "1" || param === "true") return true;
    if (param === "0" || param === "false") return false;
    var now = new Date();
    return now.getHours() === DAWN_HOUR && now.getMinutes() === DAWN_MINUTE;
  }

  function initDawn() {
    if (document.body.dataset.dawnMode === "off") return;
    var apply = function () {
      var html = document.documentElement;
      var want = shouldBeDawn();
      var has = html.classList.contains("dawn");
      if (want === has) return;
      html.classList.add("theme-anim");
      html.classList.toggle("dawn", want);
      window.setTimeout(function () { html.classList.remove("theme-anim"); }, 1100);
    };
    apply();
    window.setInterval(apply, 1000);
  }

  /* ------------------------------------------------------------ cursor light */
  function initCursorLight() {
    var el = document.querySelector(".cursor-light");
    if (!el) return;
    if (reduceMotion || window.matchMedia("(hover: none)").matches) return;

    var tx = window.innerWidth / 2, ty = window.innerHeight / 2;
    var cx = tx, cy = ty;

    window.addEventListener("pointermove", function (e) {
      tx = e.clientX; ty = e.clientY;
    }, { passive: true });

    (function loop() {
      cx += (tx - cx) * 0.12;
      cy += (ty - cy) * 0.12;
      el.style.setProperty("--mx", cx + "px");
      el.style.setProperty("--my", cy + "px");
      requestAnimationFrame(loop);
    })();
  }

  /* ------------------------------------------------ reveals + kinetic text */
  function initReveals() {
    var revealEls = document.querySelectorAll("[data-reveal]");
    var kineticEls = document.querySelectorAll("[data-kinetic]");

    // Split kinetic headlines into word masks.
    kineticEls.forEach(function (el) {
      if (el.dataset.kineticReady) return;
      el.dataset.kineticReady = "1";
      var stagger = parseFloat(el.dataset.stagger || "0.06");
      var delay = parseFloat(el.dataset.delay || "0");
      var words = (el.textContent || "").trim().split(/\s+/);
      el.textContent = "";
      words.forEach(function (w, i) {
        var mask = document.createElement("span");
        mask.className = "kw";
        var inner = document.createElement("span");
        inner.textContent = w + (i < words.length - 1 ? "\u00A0" : "");
        inner.style.setProperty("--kd", (delay + i * stagger) + "s");
        mask.appendChild(inner);
        el.appendChild(mask);
      });
    });

    if (reduceMotion || !("IntersectionObserver" in window)) {
      revealEls.forEach(function (el) { el.classList.add("is-shown"); });
      kineticEls.forEach(function (el) { el.classList.add("is-shown"); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-shown");
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -12% 0px" });

    revealEls.forEach(function (el) { io.observe(el); });
    kineticEls.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------ header */
  function initHeader() {
    var header = document.querySelector(".n-header");
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 24);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    var burger = header.querySelector(".n-burger");
    if (burger) {
      burger.addEventListener("click", function () {
        var open = header.classList.toggle("is-open");
        burger.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }
  }

  /* -------------------------------------------------- 7-segment LED display */
  var SEGMENTS = {
    "0": "abcdef", "1": "bc", "2": "abged", "3": "abgcd", "4": "fgbc",
    "5": "afgcd", "6": "afgecd", "7": "abc", "8": "abcdefg", "9": "abcdfg",
    "-": "g", " ": ""
  };
  var T = 16, HW = T / 2;
  function segH(cy) {
    var x1 = 22, x2 = 78;
    return x1 + "," + cy + " " + (x1 + HW) + "," + (cy - HW) + " " + (x2 - HW) + "," + (cy - HW) + " " + x2 + "," + cy + " " + (x2 - HW) + "," + (cy + HW) + " " + (x1 + HW) + "," + (cy + HW);
  }
  function segV(cx, y1, y2) {
    return cx + "," + y1 + " " + (cx + HW) + "," + (y1 + HW) + " " + (cx + HW) + "," + (y2 - HW) + " " + cx + "," + y2 + " " + (cx - HW) + "," + (y2 - HW) + " " + (cx - HW) + "," + (y1 + HW);
  }
  var SEG_POINTS = {
    a: segH(18), g: segH(90), d: segH(162),
    f: segV(18, 22, 86), b: segV(82, 22, 86),
    e: segV(18, 94, 158), c: segV(82, 94, 158)
  };
  var SVG_NS = "http://www.w3.org/2000/svg";

  function digitSvg(char, color) {
    var lit = SEGMENTS[char] || "";
    var svg = document.createElementNS(SVG_NS, "svg");
    svg.setAttribute("viewBox", "0 0 100 180");
    svg.setAttribute("aria-hidden", "true");
    ["a", "b", "c", "d", "e", "f", "g"].forEach(function (s) {
      var on = lit.indexOf(s) !== -1;
      var poly = document.createElementNS(SVG_NS, "polygon");
      poly.setAttribute("points", SEG_POINTS[s]);
      poly.setAttribute("fill", color);
      poly.setAttribute("opacity", on ? "1" : "0.07");
      if (on) poly.style.filter = "drop-shadow(0 0 5px " + color + ")";
      svg.appendChild(poly);
    });
    return svg;
  }

  function colonSvg(color, blink) {
    var svg = document.createElementNS(SVG_NS, "svg");
    svg.setAttribute("viewBox", "0 0 40 180");
    svg.setAttribute("aria-hidden", "true");
    if (blink && !reduceMotion) svg.classList.add("led-blink");
    [66, 114].forEach(function (cy) {
      var c = document.createElementNS(SVG_NS, "circle");
      c.setAttribute("cx", "20");
      c.setAttribute("cy", String(cy));
      c.setAttribute("r", "8.5");
      c.setAttribute("fill", color);
      c.style.filter = "drop-shadow(0 0 5px " + color + ")";
      svg.appendChild(c);
    });
    return svg;
  }

  function renderSevenSegment(container, value, color, blink) {
    container.innerHTML = "";
    container.setAttribute("role", "img");
    container.setAttribute("aria-label", value);
    value.split("").forEach(function (char) {
      container.appendChild(char === ":" ? colonSvg(color, blink) : digitSvg(char, color));
    });
  }

  /* --------------------------------------------------------- <null-clock> */
  function pad(n) { return String(n).padStart(2, "0"); }

  var NullClock = function () {
    var el = Reflect.construct(HTMLElement, [], NullClock);
    return el;
  };
  NullClock.prototype = Object.create(HTMLElement.prototype);
  NullClock.prototype.connectedCallback = function () {
    var seg = this.querySelector("[data-seg]");
    if (seg) renderSevenSegment(seg, this.dataset.value || "03:17", "var(--color-alert)", true);

    var localEl = this.querySelector("[data-local]");
    var cdEl = this.querySelector("[data-countdown]");
    var targetMs = this.dataset.target ? new Date(this.dataset.target).getTime() : NaN;

    function tick() {
      var now = new Date();
      if (localEl) {
        var h12 = now.getHours() % 12 || 12;
        var ampm = now.getHours() >= 12 ? "PM" : "AM";
        localEl.textContent = pad(h12) + ":" + pad(now.getMinutes()) + " " + ampm;
      }
      if (cdEl && !isNaN(targetMs)) {
        var delta = targetMs - Date.now();
        if (delta <= 0) { cdEl.textContent = "\u2014"; return; }
        var d = Math.floor(delta / 86400000);
        var h = Math.floor((delta % 86400000) / 3600000);
        var m = Math.floor((delta % 3600000) / 60000);
        var s = Math.floor((delta % 60000) / 1000);
        cdEl.textContent = d + "d " + pad(h) + ":" + pad(m) + ":" + pad(s);
      }
    }
    tick();
    this._timer = window.setInterval(tick, 1000);
  };
  NullClock.prototype.disconnectedCallback = function () {
    if (this._timer) window.clearInterval(this._timer);
  };
  if (!customElements.get("null-clock")) customElements.define("null-clock", NullClock);

  /* ----------------------------------------------------- <null-breathing> */
  var PHASES = [
    { key: "inhale", label: "Breathe in", seconds: 4, scale: 1 },
    { key: "hold", label: "Hold", seconds: 7, scale: 1 },
    { key: "exhale", label: "Breathe out", seconds: 8, scale: 0.55 }
  ];

  var NullBreathing = function () {
    var el = Reflect.construct(HTMLElement, [], NullBreathing);
    return el;
  };
  NullBreathing.prototype = Object.create(HTMLElement.prototype);
  NullBreathing.prototype.connectedCallback = function () {
    var root = this;
    var running = false, started = false, phaseIndex = 0, cycles = 0;
    var phaseTimer = null, countTimer = null;

    var wrap = root.querySelector(".n-breathe");
    var glow = root.querySelector(".n-breathe__glow");
    var disc = root.querySelector(".n-breathe__disc");
    var ringFill = root.querySelector(".n-breathe__ring .fill");
    var phaseEl = root.querySelector(".n-breathe__phase");
    var countEl = root.querySelector(".n-breathe__count");
    var dots = root.querySelectorAll(".n-breathe__dots span");
    var btn = root.querySelector(".n-breathe__btn");
    var resetBtn = root.querySelector(".n-breathe__reset");
    var meta = root.querySelector(".n-breathe__meta .rounds");

    function setScale(scale, durSec) {
      var d = (reduceMotion ? 0.4 : durSec) + "s";
      wrap.style.setProperty("--bx-dur", d);
      if (!reduceMotion) {
        glow.style.transform = "scale(" + scale + ")";
        disc.style.transform = "scale(" + scale + ")";
      }
    }

    function paintIdle() {
      phaseEl.textContent = "Ready";
      countEl.textContent = String(PHASES[phaseIndex].seconds);
      dots.forEach(function (d) { d.classList.remove("active"); });
      if (ringFill) {
        ringFill.classList.remove("animating");
        ringFill.style.strokeDashoffset = "754";
      }
      glow.style.opacity = "0.12";
      setScale(0.7, 0.4);
    }

    function runPhase() {
      var phase = PHASES[phaseIndex];
      phaseEl.textContent = phase.label;
      countEl.textContent = String(phase.seconds);
      dots.forEach(function (d, i) { d.classList.toggle("active", i === phaseIndex); });
      glow.style.opacity = "0.26";
      setScale(reduceMotion ? 1 : phase.scale, phase.seconds);

      if (ringFill) {
        ringFill.classList.remove("animating");
        ringFill.style.strokeDashoffset = "754";
        void ringFill.getBoundingClientRect();
        wrap.style.setProperty("--bx-dur", phase.seconds + "s");
        ringFill.classList.add("animating");
      }

      var startMs = Date.now();
      var durMs = phase.seconds * 1000;
      countTimer = window.setInterval(function () {
        var left = Math.max(0, Math.ceil((durMs - (Date.now() - startMs)) / 1000));
        countEl.textContent = String(left);
      }, 150);

      phaseTimer = window.setTimeout(function () {
        window.clearInterval(countTimer);
        phaseIndex = (phaseIndex + 1) % PHASES.length;
        if (phaseIndex === 0) {
          cycles += 1;
          if (meta) {
            meta.textContent = " \u2014 " + cycles + (cycles === 1 ? " round" : " rounds");
          }
        }
        if (running) runPhase();
      }, durMs);
    }

    function stopTimers() {
      if (phaseTimer) window.clearTimeout(phaseTimer);
      if (countTimer) window.clearInterval(countTimer);
    }

    btn.addEventListener("click", function () {
      started = true;
      wrap.classList.add("started");
      running = !running;
      btn.textContent = running ? "Pause" : "Resume";
      if (running) runPhase();
      else { stopTimers(); glow.style.opacity = "0.12"; setScale(0.7, 0.4); }
    });

    resetBtn.addEventListener("click", function () {
      running = false; started = false; phaseIndex = 0; cycles = 0;
      stopTimers();
      wrap.classList.remove("started");
      btn.textContent = "Begin";
      if (meta) meta.textContent = "";
      paintIdle();
    });

    paintIdle();
  };
  if (!customElements.get("null-breathing")) customElements.define("null-breathing", NullBreathing);

  /* ------------------------------------------------------- <null-archive> */
  var NullArchive = function () {
    var el = Reflect.construct(HTMLElement, [], NullArchive);
    return el;
  };
  NullArchive.prototype = Object.create(HTMLElement.prototype);
  NullArchive.prototype.connectedCallback = function () {
    var root = this;
    var key = (root.dataset.key || "0317").toLowerCase();
    var rows = root.querySelectorAll(".n-archive__row[data-sealed]");
    var counter = root.querySelector("[data-decoded-count]");
    var form = root.querySelector("form");
    var input = root.querySelector(".n-archive__key");

    function updateCount() {
      if (!counter) return;
      var shown = root.querySelectorAll(".n-archive__row.revealed[data-sealed], .n-archive__row[data-decoded]").length;
      counter.textContent = pad(shown);
    }

    rows.forEach(function (row) {
      var btn = row.querySelector("button.n-archive__item");
      if (!btn) return;
      btn.addEventListener("click", function () {
        row.classList.toggle("revealed");
        btn.setAttribute("aria-expanded", row.classList.contains("revealed") ? "true" : "false");
        updateCount();
      });
    });

    if (form && input) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (input.value.trim().toLowerCase() === key) {
          root.classList.add("decoded");
          input.classList.remove("err");
          rows.forEach(function (row) { row.classList.add("revealed"); });
          updateCount();
        } else {
          input.classList.add("err");
        }
      });
      input.addEventListener("input", function () { input.classList.remove("err"); });
    }
    updateCount();
  };
  if (!customElements.get("null-archive")) customElements.define("null-archive", NullArchive);

  /* -------------------------------------------------------- <null-states> */
  var NullStates = function () {
    var el = Reflect.construct(HTMLElement, [], NullStates);
    return el;
  };
  NullStates.prototype = Object.create(HTMLElement.prototype);
  NullStates.prototype.connectedCallback = function () {
    var root = this;
    var buttons = root.querySelectorAll(".n-states__glyphs button");
    var caption = root.querySelector(".n-states__caption");
    if (!caption) return;
    var initial = caption.innerHTML;

    function show(i) {
      var btn = buttons[i];
      var decoded = btn.classList.contains("decoded");
      var tagline = btn.dataset.tagline || "";
      buttons.forEach(function (b, j) { b.classList.toggle("active", j === i); });
      if (decoded) {
        caption.classList.add("decoded");
        caption.innerHTML = '<span class="lead">01 / 05</span> \u2014 ' + tagline;
      } else {
        caption.classList.remove("decoded");
        caption.innerHTML = pad(i + 1) + ' / 05 \u2014 ' + tagline + ' <span class="enc">[ENCRYPTED]</span>';
      }
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener("mouseenter", function () { show(i); });
      btn.addEventListener("focus", function () { show(i); });
      btn.addEventListener("mouseleave", function () { show(0); });
      btn.addEventListener("blur", function () { show(0); });
    });
    void initial;
    show(0);
  };
  if (!customElements.get("null-states")) customElements.define("null-states", NullStates);

  /* --------------------------------------------------- product form helper */
  function highlightSizeColumn(value) {
    var chart = document.querySelector("[data-size-chart] table");
    if (!chart || !chart.rows.length || !value) return;
    var header = chart.rows[0];
    var wanted = String(value).trim().toLowerCase();
    var start = -1;
    var span = 0;
    var col = 0;
    for (var i = 0; i < header.cells.length; i++) {
      var cs = header.cells[i].colSpan || 1;
      if (header.cells[i].textContent.trim().toLowerCase() === wanted) {
        start = col;
        span = cs;
      }
      col += cs;
    }
    Array.prototype.forEach.call(chart.rows, function (row) {
      var pos = 0;
      Array.prototype.forEach.call(row.cells, function (cell) {
        var w = cell.colSpan || 1;
        var hit = start > -1 && pos < start + span && pos + w > start;
        cell.classList.toggle("is-active", hit);
        pos += w;
      });
    });
  }

  function initProductForms() {
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      var dataEl = form.querySelector("[data-variant-data]");
      var idInput = form.querySelector("[data-variant-id]");
      if (!dataEl || !idInput) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var priceEl = document.querySelector("[data-product-price]");
      var stockEl = document.querySelector("[data-stock-note]");
      var buyBtn = form.querySelector("[data-add-to-cart]");
      var pickers = Array.prototype.slice.call(form.querySelectorAll("[data-option-picker]"));

      var current = variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || variants[0];
      var selections = current ? current.options.slice() : [];

      function findVariant(opts) {
        return variants.filter(function (v) {
          return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
        })[0];
      }

      function sizePicker() {
        var byName = pickers.filter(function (p) { return /size/i.test(p.dataset.optionName || ""); })[0];
        return byName || (pickers.length === 1 ? pickers[0] : null);
      }

      function refreshSoldout() {
        pickers.forEach(function (picker) {
          var idx = parseInt(picker.dataset.optionIndex, 10);
          picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
            var test = selections.slice();
            test[idx] = input.value;
            var v = findVariant(test);
            var label = picker.querySelector('label[for="' + input.id + '"]');
            if (label) label.classList.toggle("soldout", !(v && v.available));
          });
        });
      }

      function update() {
        var variant = findVariant(selections);
        if (variant) {
          idInput.value = variant.id;
          if (priceEl) {
            priceEl.innerHTML = (variant.compare ? "<s>" + variant.compare + "</s> " : "") + variant.price;
          }
          try {
            var url = new URL(window.location.href);
            url.searchParams.set("variant", variant.id);
            window.history.replaceState({}, "", url);
          } catch (e) { /* older browsers: skip URL sync */ }
        }
        if (buyBtn) {
          var ok = !!(variant && variant.available);
          buyBtn.disabled = !ok;
          buyBtn.textContent = ok ? (buyBtn.dataset.label || "Add to cart") : "Sold out";
        }
        if (stockEl && variant) {
          stockEl.textContent = variant.available ? stockEl.textContent : "Sold out";
        }
        refreshSoldout();
        var sp = sizePicker();
        if (sp) {
          var idx = parseInt(sp.dataset.optionIndex, 10);
          highlightSizeColumn(selections[idx]);
        }
      }

      pickers.forEach(function (picker) {
        var idx = parseInt(picker.dataset.optionIndex, 10);
        var legend = picker.querySelector("[data-option-current]");
        picker.addEventListener("change", function (e) {
          if (!e.target || e.target.name !== "opt-" + idx) return;
          selections[idx] = e.target.value;
          if (legend) legend.textContent = e.target.value;
          update();
        });
      });

      update();
    });
  }

  /* ---------------------------------------------------- product gallery */
  function initProductGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
      var slides = gallery.querySelectorAll("[data-slide]");
      var thumbs = gallery.querySelectorAll("[data-thumb]");
      if (!thumbs.length) return;

      function show(index) {
        slides.forEach(function (slide) {
          slide.classList.toggle("is-active", slide.dataset.slide === String(index));
        });
        thumbs.forEach(function (thumb) {
          var on = thumb.dataset.thumb === String(index);
          thumb.classList.toggle("is-active", on);
          thumb.setAttribute("aria-selected", on ? "true" : "false");
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () { show(thumb.dataset.thumb); });
        thumb.addEventListener("mouseenter", function () { show(thumb.dataset.thumb); });
      });
    });
  }

  /* ------------------------------------------------ dossier clock (03:17) */
  function initDossierClock() {
    var el = document.querySelector("[data-until-317]");
    if (!el) return;
    var localEl = el.querySelector("[data-local-time]");
    var untilEl = el.querySelector("[data-until-value]");
    function pad(n) { return String(n < 10 ? "0" + n : n); }
    function tick() {
      var now = new Date();
      if (localEl) localEl.textContent = pad(now.getHours()) + ":" + pad(now.getMinutes()) + ":" + pad(now.getSeconds());
      var target = new Date(now.getTime());
      target.setHours(3, 17, 0, 0);
      if (target <= now) target.setDate(target.getDate() + 1);
      var s = Math.floor((target.getTime() - now.getTime()) / 1000);
      var h = Math.floor(s / 3600);
      var m = Math.floor((s % 3600) / 60);
      if (untilEl) untilEl.textContent = pad(h) + "h " + pad(m) + "m " + pad(s % 60) + "s";
    }
    el.hidden = false;
    tick();
    setInterval(tick, 1000);
  }

  /* --------------------------------------------------- waitlist tag builder */
  function initWaitlistForms() {
    document.querySelectorAll("form").forEach(function (form) {
      var tagsInput = form.querySelector("[data-waitlist-tags]");
      if (!tagsInput) return;
      form.addEventListener("submit", function () {
        var base = tagsInput.getAttribute("value") || "waitlist, 0317";
        var tags = base.split(",").map(function (t) { return t.trim(); }).filter(Boolean);
        var interest = form.querySelector("[data-waitlist-interest]");
        var size = form.querySelector("[data-waitlist-size]");
        if (interest && interest.value) tags.push("interest:" + interest.value);
        if (size && size.value) tags.push("size:" + size.value);
        tagsInput.value = tags.join(", ");
      });
    });
  }

  /* -------------------------------------------------------------------- go */
  function init() {
    initDawn();
    initCursorLight();
    initReveals();
    initHeader();
    initProductForms();
    initProductGallery();
    initDossierClock();
    initWaitlistForms();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
